const theme = {
    primary: "#7D3CE8",
    secondary: "#7ACDD4",
    text: "#686868",
    bg: "#FFFFFF"
};

export default theme